// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file penumbra/core/transaction/v1/transaction.proto (package penumbra.core.transaction.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Any, Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { BindingSignature, SpendAuthSignature } from "../../../crypto/decaf377_rdsa/v1/decaf377_rdsa_pb.js";
import { MerkleRoot, StateCommitment, StateCommitmentProof } from "../../../crypto/tct/v1/tct_pb.js";
import { Fee } from "../../component/fee/v1/fee_pb.js";
import { Address, AddressView, PayloadKey } from "../../keys/v1/keys_pb.js";
import { AssetId, Balance, EstimatedPrice, Metadata } from "../../asset/v1/asset_pb.js";
import { Clue } from "../../../crypto/decaf377_fmd/v1/decaf377_fmd_pb.js";
import { Note, Output, OutputPlan, OutputView, Spend, SpendPlan, SpendView } from "../../component/shielded_pool/v1/shielded_pool_pb.js";
import { BatchSwapOutputData, PositionClose, PositionOpen, PositionRewardClaim, PositionRewardClaimPlan, PositionWithdraw, PositionWithdrawPlan, Swap, SwapClaim, SwapClaimPlan, SwapClaimView, SwapPlan, SwapView } from "../../component/dex/v1/dex_pb.js";
import { Delegate, Undelegate, UndelegateClaim, UndelegateClaimPlan, ValidatorDefinition } from "../../component/stake/v1/stake_pb.js";
import { IbcRelay, Ics20Withdrawal } from "../../component/ibc/v1/ibc_pb.js";
import { CommunityPoolDeposit, CommunityPoolOutput, CommunityPoolSpend, DelegatorVote, DelegatorVotePlan, DelegatorVoteView, ProposalDepositClaim, ProposalSubmit, ProposalWithdraw, ValidatorVote } from "../../component/governance/v1/governance_pb.js";
import { ActionDutchAuctionEnd, ActionDutchAuctionSchedule, ActionDutchAuctionScheduleView, ActionDutchAuctionWithdraw, ActionDutchAuctionWithdrawPlan, ActionDutchAuctionWithdrawView } from "../../component/auction/v1/auction_pb.js";
import { EffectHash, TransactionId } from "../../txhash/v1/txhash_pb.js";
import { Nullifier } from "../../component/sct/v1/sct_pb.js";
/**
 * A Penumbra transaction.
 *
 * @generated from message penumbra.core.transaction.v1.Transaction
 */
export class Transaction extends Message {
    /**
     * @generated from field: penumbra.core.transaction.v1.TransactionBody body = 1;
     */
    body;
    /**
     * The binding signature is stored separately from the transaction body that it signs.
     *
     * @generated from field: penumbra.crypto.decaf377_rdsa.v1.BindingSignature binding_sig = 2;
     */
    bindingSig;
    /**
     * The root of some previous state of the state commitment tree, used as an anchor for all
     * ZK state transition proofs.
     *
     * @generated from field: penumbra.crypto.tct.v1.MerkleRoot anchor = 3;
     */
    anchor;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.Transaction";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "body", kind: "message", T: TransactionBody },
        { no: 2, name: "binding_sig", kind: "message", T: BindingSignature },
        { no: 3, name: "anchor", kind: "message", T: MerkleRoot },
    ]);
    static fromBinary(bytes, options) {
        return new Transaction().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Transaction().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Transaction().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Transaction, a, b);
    }
}
/**
 * The body of a transaction.
 *
 * @generated from message penumbra.core.transaction.v1.TransactionBody
 */
export class TransactionBody extends Message {
    /**
     * A list of actions (state changes) performed by this transaction.
     *
     * @generated from field: repeated penumbra.core.transaction.v1.Action actions = 1;
     */
    actions = [];
    /**
     * Parameters determining if a transaction should be accepted by this chain.
     *
     * @generated from field: penumbra.core.transaction.v1.TransactionParameters transaction_parameters = 2;
     */
    transactionParameters;
    /**
     * Detection data for use with Fuzzy Message Detection
     *
     * @generated from field: penumbra.core.transaction.v1.DetectionData detection_data = 4;
     */
    detectionData;
    /**
     * The encrypted memo for this transaction.
     *
     * This field will be present if and only if the transaction has outputs.
     *
     * @generated from field: penumbra.core.transaction.v1.MemoCiphertext memo = 5;
     */
    memo;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.TransactionBody";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "actions", kind: "message", T: Action, repeated: true },
        { no: 2, name: "transaction_parameters", kind: "message", T: TransactionParameters },
        { no: 4, name: "detection_data", kind: "message", T: DetectionData },
        { no: 5, name: "memo", kind: "message", T: MemoCiphertext },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionBody().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionBody().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionBody().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionBody, a, b);
    }
}
/**
 * The parameters determining if a transaction should be accepted by the chain.
 *
 * @generated from message penumbra.core.transaction.v1.TransactionParameters
 */
export class TransactionParameters extends Message {
    /**
     * The maximum height that this transaction can be included in the chain.
     *
     * If zero, there is no maximum.
     *
     * @generated from field: uint64 expiry_height = 1;
     */
    expiryHeight = protoInt64.zero;
    /**
     * The chain this transaction is intended for.  Including this prevents
     * replaying a transaction on one chain onto a different chain.
     *
     * @generated from field: string chain_id = 2;
     */
    chainId = "";
    /**
     * The transaction fee.
     *
     * @generated from field: penumbra.core.component.fee.v1.Fee fee = 3;
     */
    fee;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.TransactionParameters";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "expiry_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 2, name: "chain_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "fee", kind: "message", T: Fee },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionParameters().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionParameters().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionParameters().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionParameters, a, b);
    }
}
/**
 * Represents a transaction summary containing multiple effects.
 *
 * @generated from message penumbra.core.transaction.v1.TransactionSummary
 */
export class TransactionSummary extends Message {
    /**
     * @generated from field: repeated penumbra.core.transaction.v1.TransactionSummary.Effects effects = 1;
     */
    effects = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.TransactionSummary";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "effects", kind: "message", T: TransactionSummary_Effects, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionSummary, a, b);
    }
}
/**
 * Represents an individual effect of a transaction.
 *
 * @generated from message penumbra.core.transaction.v1.TransactionSummary.Effects
 */
export class TransactionSummary_Effects extends Message {
    /**
     * @generated from field: penumbra.core.keys.v1.AddressView address = 1;
     */
    address;
    /**
     * @generated from field: penumbra.core.asset.v1.Balance balance = 2;
     */
    balance;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.TransactionSummary.Effects";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "address", kind: "message", T: AddressView },
        { no: 2, name: "balance", kind: "message", T: Balance },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionSummary_Effects().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionSummary_Effects().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionSummary_Effects().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionSummary_Effects, a, b);
    }
}
/**
 * Detection data used by a detection server performing Fuzzy Message Detection.
 *
 * @generated from message penumbra.core.transaction.v1.DetectionData
 */
export class DetectionData extends Message {
    /**
     * A list of clues for use with Fuzzy Message Detection.
     *
     * @generated from field: repeated penumbra.crypto.decaf377_fmd.v1.Clue fmd_clues = 4;
     */
    fmdClues = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.DetectionData";
    static fields = proto3.util.newFieldList(() => [
        { no: 4, name: "fmd_clues", kind: "message", T: Clue, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new DetectionData().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DetectionData().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DetectionData().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DetectionData, a, b);
    }
}
/**
 * A state change performed by a transaction.
 *
 * @generated from message penumbra.core.transaction.v1.Action
 */
export class Action extends Message {
    /**
     * @generated from oneof penumbra.core.transaction.v1.Action.action
     */
    action = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.Action";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "spend", kind: "message", T: Spend, oneof: "action" },
        { no: 2, name: "output", kind: "message", T: Output, oneof: "action" },
        { no: 3, name: "swap", kind: "message", T: Swap, oneof: "action" },
        { no: 4, name: "swap_claim", kind: "message", T: SwapClaim, oneof: "action" },
        { no: 16, name: "validator_definition", kind: "message", T: ValidatorDefinition, oneof: "action" },
        { no: 17, name: "ibc_relay_action", kind: "message", T: IbcRelay, oneof: "action" },
        { no: 18, name: "proposal_submit", kind: "message", T: ProposalSubmit, oneof: "action" },
        { no: 19, name: "proposal_withdraw", kind: "message", T: ProposalWithdraw, oneof: "action" },
        { no: 20, name: "validator_vote", kind: "message", T: ValidatorVote, oneof: "action" },
        { no: 21, name: "delegator_vote", kind: "message", T: DelegatorVote, oneof: "action" },
        { no: 22, name: "proposal_deposit_claim", kind: "message", T: ProposalDepositClaim, oneof: "action" },
        { no: 30, name: "position_open", kind: "message", T: PositionOpen, oneof: "action" },
        { no: 31, name: "position_close", kind: "message", T: PositionClose, oneof: "action" },
        { no: 32, name: "position_withdraw", kind: "message", T: PositionWithdraw, oneof: "action" },
        { no: 34, name: "position_reward_claim", kind: "message", T: PositionRewardClaim, oneof: "action" },
        { no: 40, name: "delegate", kind: "message", T: Delegate, oneof: "action" },
        { no: 41, name: "undelegate", kind: "message", T: Undelegate, oneof: "action" },
        { no: 42, name: "undelegate_claim", kind: "message", T: UndelegateClaim, oneof: "action" },
        { no: 50, name: "community_pool_spend", kind: "message", T: CommunityPoolSpend, oneof: "action" },
        { no: 51, name: "community_pool_output", kind: "message", T: CommunityPoolOutput, oneof: "action" },
        { no: 52, name: "community_pool_deposit", kind: "message", T: CommunityPoolDeposit, oneof: "action" },
        { no: 53, name: "action_dutch_auction_schedule", kind: "message", T: ActionDutchAuctionSchedule, oneof: "action" },
        { no: 54, name: "action_dutch_auction_end", kind: "message", T: ActionDutchAuctionEnd, oneof: "action" },
        { no: 55, name: "action_dutch_auction_withdraw", kind: "message", T: ActionDutchAuctionWithdraw, oneof: "action" },
        { no: 200, name: "ics20_withdrawal", kind: "message", T: Ics20Withdrawal, oneof: "action" },
    ]);
    static fromBinary(bytes, options) {
        return new Action().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Action().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Action().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Action, a, b);
    }
}
/**
 * A transaction perspective is a bundle of key material and commitment openings
 * that allow generating a view of a transaction from that perspective.
 *
 * @generated from message penumbra.core.transaction.v1.TransactionPerspective
 */
export class TransactionPerspective extends Message {
    /**
     * @generated from field: repeated penumbra.core.transaction.v1.PayloadKeyWithCommitment payload_keys = 1;
     */
    payloadKeys = [];
    /**
     * @generated from field: repeated penumbra.core.transaction.v1.NullifierWithNote spend_nullifiers = 2;
     */
    spendNullifiers = [];
    /**
     * The openings of note commitments referred to in the transaction
     * but not included in the transaction.
     *
     * @generated from field: repeated penumbra.core.component.shielded_pool.v1.Note advice_notes = 3;
     */
    adviceNotes = [];
    /**
     * Any relevant address views.
     *
     * @generated from field: repeated penumbra.core.keys.v1.AddressView address_views = 4;
     */
    addressViews = [];
    /**
     * Any relevant denoms for viewed assets.
     *
     * @generated from field: repeated penumbra.core.asset.v1.Metadata denoms = 5;
     */
    denoms = [];
    /**
     * The transaction ID associated with this TransactionPerspective
     *
     * @generated from field: penumbra.core.txhash.v1.TransactionId transaction_id = 6;
     */
    transactionId;
    /**
     * Any relevant estimated prices
     *
     * @generated from field: repeated penumbra.core.asset.v1.EstimatedPrice prices = 20;
     */
    prices = [];
    /**
     * Any relevant extended metadata, indexed by asset id.
     *
     * @generated from field: repeated penumbra.core.transaction.v1.TransactionPerspective.ExtendedMetadataById extended_metadata = 30;
     */
    extendedMetadata = [];
    /**
     * @generated from field: repeated penumbra.core.transaction.v1.TransactionPerspective.CreationTransactionIdByNullifier creation_transaction_ids_by_nullifier = 40;
     */
    creationTransactionIdsByNullifier = [];
    /**
     * @generated from field: repeated penumbra.core.transaction.v1.TransactionPerspective.NullificationTransactionIdByCommitment nullification_transaction_ids_by_commitment = 50;
     */
    nullificationTransactionIdsByCommitment = [];
    /**
     * Any relevant BatchSwapOutputData to the transaction.
     *
     * This can be used to fill in information about swap outputs.
     *
     * @generated from field: repeated penumbra.core.component.dex.v1.BatchSwapOutputData batch_swap_output_data = 60;
     */
    batchSwapOutputData = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.TransactionPerspective";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "payload_keys", kind: "message", T: PayloadKeyWithCommitment, repeated: true },
        { no: 2, name: "spend_nullifiers", kind: "message", T: NullifierWithNote, repeated: true },
        { no: 3, name: "advice_notes", kind: "message", T: Note, repeated: true },
        { no: 4, name: "address_views", kind: "message", T: AddressView, repeated: true },
        { no: 5, name: "denoms", kind: "message", T: Metadata, repeated: true },
        { no: 6, name: "transaction_id", kind: "message", T: TransactionId },
        { no: 20, name: "prices", kind: "message", T: EstimatedPrice, repeated: true },
        { no: 30, name: "extended_metadata", kind: "message", T: TransactionPerspective_ExtendedMetadataById, repeated: true },
        { no: 40, name: "creation_transaction_ids_by_nullifier", kind: "message", T: TransactionPerspective_CreationTransactionIdByNullifier, repeated: true },
        { no: 50, name: "nullification_transaction_ids_by_commitment", kind: "message", T: TransactionPerspective_NullificationTransactionIdByCommitment, repeated: true },
        { no: 60, name: "batch_swap_output_data", kind: "message", T: BatchSwapOutputData, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionPerspective().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionPerspective().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionPerspective().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionPerspective, a, b);
    }
}
/**
 * @generated from message penumbra.core.transaction.v1.TransactionPerspective.ExtendedMetadataById
 */
export class TransactionPerspective_ExtendedMetadataById extends Message {
    /**
     * @generated from field: penumbra.core.asset.v1.AssetId asset_id = 1;
     */
    assetId;
    /**
     * @generated from field: google.protobuf.Any extended_metadata = 2;
     */
    extendedMetadata;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.TransactionPerspective.ExtendedMetadataById";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "asset_id", kind: "message", T: AssetId },
        { no: 2, name: "extended_metadata", kind: "message", T: Any },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionPerspective_ExtendedMetadataById().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionPerspective_ExtendedMetadataById().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionPerspective_ExtendedMetadataById().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionPerspective_ExtendedMetadataById, a, b);
    }
}
/**
 * Associates a nullifier with the transaction ID that created the nullified state commitment.
 *
 * Note: this is _not_ the transaction ID that revealed the nullifier.
 *
 * Allows walking backwards from a spend to the transaction that created the note.
 *
 * @generated from message penumbra.core.transaction.v1.TransactionPerspective.CreationTransactionIdByNullifier
 */
export class TransactionPerspective_CreationTransactionIdByNullifier extends Message {
    /**
     * @generated from field: penumbra.core.component.sct.v1.Nullifier nullifier = 1;
     */
    nullifier;
    /**
     * @generated from field: penumbra.core.txhash.v1.TransactionId transaction_id = 2;
     */
    transactionId;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.TransactionPerspective.CreationTransactionIdByNullifier";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "nullifier", kind: "message", T: Nullifier },
        { no: 2, name: "transaction_id", kind: "message", T: TransactionId },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionPerspective_CreationTransactionIdByNullifier().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionPerspective_CreationTransactionIdByNullifier().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionPerspective_CreationTransactionIdByNullifier().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionPerspective_CreationTransactionIdByNullifier, a, b);
    }
}
/**
 * Associates a commitment with the transaction ID that eventually nullified it.
 *
 * Allows walking forwards from an output to the transaction that spent the note.
 *
 * @generated from message penumbra.core.transaction.v1.TransactionPerspective.NullificationTransactionIdByCommitment
 */
export class TransactionPerspective_NullificationTransactionIdByCommitment extends Message {
    /**
     * @generated from field: penumbra.crypto.tct.v1.StateCommitment commitment = 1;
     */
    commitment;
    /**
     * @generated from field: penumbra.core.txhash.v1.TransactionId transaction_id = 2;
     */
    transactionId;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.TransactionPerspective.NullificationTransactionIdByCommitment";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "commitment", kind: "message", T: StateCommitment },
        { no: 2, name: "transaction_id", kind: "message", T: TransactionId },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionPerspective_NullificationTransactionIdByCommitment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionPerspective_NullificationTransactionIdByCommitment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionPerspective_NullificationTransactionIdByCommitment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionPerspective_NullificationTransactionIdByCommitment, a, b);
    }
}
/**
 * @generated from message penumbra.core.transaction.v1.PayloadKeyWithCommitment
 */
export class PayloadKeyWithCommitment extends Message {
    /**
     * @generated from field: penumbra.core.keys.v1.PayloadKey payload_key = 1;
     */
    payloadKey;
    /**
     * @generated from field: penumbra.crypto.tct.v1.StateCommitment commitment = 2;
     */
    commitment;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.PayloadKeyWithCommitment";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "payload_key", kind: "message", T: PayloadKey },
        { no: 2, name: "commitment", kind: "message", T: StateCommitment },
    ]);
    static fromBinary(bytes, options) {
        return new PayloadKeyWithCommitment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PayloadKeyWithCommitment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PayloadKeyWithCommitment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PayloadKeyWithCommitment, a, b);
    }
}
/**
 * @generated from message penumbra.core.transaction.v1.NullifierWithNote
 */
export class NullifierWithNote extends Message {
    /**
     * @generated from field: penumbra.core.component.sct.v1.Nullifier nullifier = 1;
     */
    nullifier;
    /**
     * @generated from field: penumbra.core.component.shielded_pool.v1.Note note = 2;
     */
    note;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.NullifierWithNote";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "nullifier", kind: "message", T: Nullifier },
        { no: 2, name: "note", kind: "message", T: Note },
    ]);
    static fromBinary(bytes, options) {
        return new NullifierWithNote().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NullifierWithNote().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NullifierWithNote().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NullifierWithNote, a, b);
    }
}
/**
 * View of a Penumbra transaction.
 *
 * @generated from message penumbra.core.transaction.v1.TransactionView
 */
export class TransactionView extends Message {
    /**
     * View of the transaction body
     *
     * @generated from field: penumbra.core.transaction.v1.TransactionBodyView body_view = 1;
     */
    bodyView;
    /**
     * The binding signature is stored separately from the transaction body that it signs.
     *
     * @generated from field: penumbra.crypto.decaf377_rdsa.v1.BindingSignature binding_sig = 2;
     */
    bindingSig;
    /**
     * The root of some previous state of the state commitment tree, used as an anchor for all
     * ZK state transition proofs.
     *
     * @generated from field: penumbra.crypto.tct.v1.MerkleRoot anchor = 3;
     */
    anchor;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.TransactionView";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "body_view", kind: "message", T: TransactionBodyView },
        { no: 2, name: "binding_sig", kind: "message", T: BindingSignature },
        { no: 3, name: "anchor", kind: "message", T: MerkleRoot },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionView, a, b);
    }
}
/**
 * @generated from message penumbra.core.transaction.v1.TransactionBodyView
 */
export class TransactionBodyView extends Message {
    /**
     * A list views into of actions (state changes) performed by this transaction.
     *
     * @generated from field: repeated penumbra.core.transaction.v1.ActionView action_views = 1;
     */
    actionViews = [];
    /**
     * Transaction parameters.
     *
     * @generated from field: penumbra.core.transaction.v1.TransactionParameters transaction_parameters = 2;
     */
    transactionParameters;
    /**
     * The detection data in this transaction, only populated if
     * there are outputs in the actions of this transaction.
     *
     * @generated from field: penumbra.core.transaction.v1.DetectionData detection_data = 4;
     */
    detectionData;
    /**
     * An optional view of a transaction memo. It will only be populated if there are
     * outputs in the actions of this transaction.
     *
     * @generated from field: penumbra.core.transaction.v1.MemoView memo_view = 5;
     */
    memoView;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.TransactionBodyView";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "action_views", kind: "message", T: ActionView, repeated: true },
        { no: 2, name: "transaction_parameters", kind: "message", T: TransactionParameters },
        { no: 4, name: "detection_data", kind: "message", T: DetectionData },
        { no: 5, name: "memo_view", kind: "message", T: MemoView },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionBodyView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionBodyView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionBodyView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionBodyView, a, b);
    }
}
/**
 * A view of a specific state change action performed by a transaction.
 *
 * @generated from message penumbra.core.transaction.v1.ActionView
 */
export class ActionView extends Message {
    /**
     * @generated from oneof penumbra.core.transaction.v1.ActionView.action_view
     */
    actionView = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.ActionView";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "spend", kind: "message", T: SpendView, oneof: "action_view" },
        { no: 2, name: "output", kind: "message", T: OutputView, oneof: "action_view" },
        { no: 3, name: "swap", kind: "message", T: SwapView, oneof: "action_view" },
        { no: 4, name: "swap_claim", kind: "message", T: SwapClaimView, oneof: "action_view" },
        { no: 21, name: "delegator_vote", kind: "message", T: DelegatorVoteView, oneof: "action_view" },
        { no: 16, name: "validator_definition", kind: "message", T: ValidatorDefinition, oneof: "action_view" },
        { no: 17, name: "ibc_relay_action", kind: "message", T: IbcRelay, oneof: "action_view" },
        { no: 18, name: "proposal_submit", kind: "message", T: ProposalSubmit, oneof: "action_view" },
        { no: 19, name: "proposal_withdraw", kind: "message", T: ProposalWithdraw, oneof: "action_view" },
        { no: 20, name: "validator_vote", kind: "message", T: ValidatorVote, oneof: "action_view" },
        { no: 22, name: "proposal_deposit_claim", kind: "message", T: ProposalDepositClaim, oneof: "action_view" },
        { no: 30, name: "position_open", kind: "message", T: PositionOpen, oneof: "action_view" },
        { no: 31, name: "position_close", kind: "message", T: PositionClose, oneof: "action_view" },
        { no: 32, name: "position_withdraw", kind: "message", T: PositionWithdraw, oneof: "action_view" },
        { no: 34, name: "position_reward_claim", kind: "message", T: PositionRewardClaim, oneof: "action_view" },
        { no: 41, name: "delegate", kind: "message", T: Delegate, oneof: "action_view" },
        { no: 42, name: "undelegate", kind: "message", T: Undelegate, oneof: "action_view" },
        { no: 50, name: "community_pool_spend", kind: "message", T: CommunityPoolSpend, oneof: "action_view" },
        { no: 51, name: "community_pool_output", kind: "message", T: CommunityPoolOutput, oneof: "action_view" },
        { no: 52, name: "community_pool_deposit", kind: "message", T: CommunityPoolDeposit, oneof: "action_view" },
        { no: 53, name: "action_dutch_auction_schedule", kind: "message", T: ActionDutchAuctionScheduleView, oneof: "action_view" },
        { no: 54, name: "action_dutch_auction_end", kind: "message", T: ActionDutchAuctionEnd, oneof: "action_view" },
        { no: 55, name: "action_dutch_auction_withdraw", kind: "message", T: ActionDutchAuctionWithdrawView, oneof: "action_view" },
        { no: 43, name: "undelegate_claim", kind: "message", T: UndelegateClaim, oneof: "action_view" },
        { no: 200, name: "ics20_withdrawal", kind: "message", T: Ics20Withdrawal, oneof: "action_view" },
    ]);
    static fromBinary(bytes, options) {
        return new ActionView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ActionView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ActionView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ActionView, a, b);
    }
}
/**
 * The data required to authorize a transaction plan.
 *
 * @generated from message penumbra.core.transaction.v1.AuthorizationData
 */
export class AuthorizationData extends Message {
    /**
     * The computed auth hash for the approved transaction plan.
     *
     * @generated from field: penumbra.core.txhash.v1.EffectHash effect_hash = 1;
     */
    effectHash;
    /**
     * The required spend authorizations, returned in the same order as the
     * Spend actions in the original request.
     *
     * @generated from field: repeated penumbra.crypto.decaf377_rdsa.v1.SpendAuthSignature spend_auths = 2;
     */
    spendAuths = [];
    /**
     * The required delegator vote authorizations, returned in the same order as the
     * DelegatorVote actions in the original request.
     *
     * @generated from field: repeated penumbra.crypto.decaf377_rdsa.v1.SpendAuthSignature delegator_vote_auths = 3;
     */
    delegatorVoteAuths = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.AuthorizationData";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "effect_hash", kind: "message", T: EffectHash },
        { no: 2, name: "spend_auths", kind: "message", T: SpendAuthSignature, repeated: true },
        { no: 3, name: "delegator_vote_auths", kind: "message", T: SpendAuthSignature, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new AuthorizationData().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuthorizationData().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuthorizationData().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuthorizationData, a, b);
    }
}
/**
 * The data required for proving when building a transaction from a plan.
 *
 * @generated from message penumbra.core.transaction.v1.WitnessData
 */
export class WitnessData extends Message {
    /**
     * The anchor for the state transition proofs.
     *
     * @generated from field: penumbra.crypto.tct.v1.MerkleRoot anchor = 1;
     */
    anchor;
    /**
     * The auth paths for the notes the transaction spends, in the
     * same order as the spends in the transaction plan.
     *
     * @generated from field: repeated penumbra.crypto.tct.v1.StateCommitmentProof state_commitment_proofs = 2;
     */
    stateCommitmentProofs = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.WitnessData";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "anchor", kind: "message", T: MerkleRoot },
        { no: 2, name: "state_commitment_proofs", kind: "message", T: StateCommitmentProof, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new WitnessData().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WitnessData().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WitnessData().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WitnessData, a, b);
    }
}
/**
 * Describes a planned transaction. Permits clients to prepare a transaction
 * prior submission, so that a user can review it prior to authorizing its execution.
 *
 * The `TransactionPlan` is a fully determined bundle binding all of a transaction's effects.
 * The only thing it does not include is the witness data used for proving.
 *
 * @generated from message penumbra.core.transaction.v1.TransactionPlan
 */
export class TransactionPlan extends Message {
    /**
     * The sequence of actions planned for this transaction.
     *
     * @generated from field: repeated penumbra.core.transaction.v1.ActionPlan actions = 1;
     */
    actions = [];
    /**
     * Parameters determining if a transaction should be accepted by this chain.
     *
     * @generated from field: penumbra.core.transaction.v1.TransactionParameters transaction_parameters = 2;
     */
    transactionParameters;
    /**
     * Detection data for use with Fuzzy Message Detection
     *
     * @generated from field: penumbra.core.transaction.v1.DetectionDataPlan detection_data = 4;
     */
    detectionData;
    /**
     * The memo plan for this transaction.
     *
     * @generated from field: penumbra.core.transaction.v1.MemoPlan memo = 5;
     */
    memo;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.TransactionPlan";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "actions", kind: "message", T: ActionPlan, repeated: true },
        { no: 2, name: "transaction_parameters", kind: "message", T: TransactionParameters },
        { no: 4, name: "detection_data", kind: "message", T: DetectionDataPlan },
        { no: 5, name: "memo", kind: "message", T: MemoPlan },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionPlan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionPlan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionPlan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionPlan, a, b);
    }
}
/**
 * @generated from message penumbra.core.transaction.v1.DetectionDataPlan
 */
export class DetectionDataPlan extends Message {
    /**
     * @generated from field: repeated penumbra.core.transaction.v1.CluePlan clue_plans = 5;
     */
    cluePlans = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.DetectionDataPlan";
    static fields = proto3.util.newFieldList(() => [
        { no: 5, name: "clue_plans", kind: "message", T: CluePlan, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new DetectionDataPlan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DetectionDataPlan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DetectionDataPlan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DetectionDataPlan, a, b);
    }
}
/**
 * Describes a planned transaction action.
 *
 * Some transaction Actions don't have any private data and are treated as being plans
 * themselves.
 *
 * @generated from message penumbra.core.transaction.v1.ActionPlan
 */
export class ActionPlan extends Message {
    /**
     * @generated from oneof penumbra.core.transaction.v1.ActionPlan.action
     */
    action = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.ActionPlan";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "spend", kind: "message", T: SpendPlan, oneof: "action" },
        { no: 2, name: "output", kind: "message", T: OutputPlan, oneof: "action" },
        { no: 3, name: "swap", kind: "message", T: SwapPlan, oneof: "action" },
        { no: 4, name: "swap_claim", kind: "message", T: SwapClaimPlan, oneof: "action" },
        { no: 16, name: "validator_definition", kind: "message", T: ValidatorDefinition, oneof: "action" },
        { no: 17, name: "ibc_relay_action", kind: "message", T: IbcRelay, oneof: "action" },
        { no: 18, name: "proposal_submit", kind: "message", T: ProposalSubmit, oneof: "action" },
        { no: 19, name: "proposal_withdraw", kind: "message", T: ProposalWithdraw, oneof: "action" },
        { no: 20, name: "validator_vote", kind: "message", T: ValidatorVote, oneof: "action" },
        { no: 21, name: "delegator_vote", kind: "message", T: DelegatorVotePlan, oneof: "action" },
        { no: 22, name: "proposal_deposit_claim", kind: "message", T: ProposalDepositClaim, oneof: "action" },
        { no: 200, name: "ics20_withdrawal", kind: "message", T: Ics20Withdrawal, oneof: "action" },
        { no: 30, name: "position_open", kind: "message", T: PositionOpen, oneof: "action" },
        { no: 31, name: "position_close", kind: "message", T: PositionClose, oneof: "action" },
        { no: 32, name: "position_withdraw", kind: "message", T: PositionWithdrawPlan, oneof: "action" },
        { no: 34, name: "position_reward_claim", kind: "message", T: PositionRewardClaimPlan, oneof: "action" },
        { no: 40, name: "delegate", kind: "message", T: Delegate, oneof: "action" },
        { no: 41, name: "undelegate", kind: "message", T: Undelegate, oneof: "action" },
        { no: 42, name: "undelegate_claim", kind: "message", T: UndelegateClaimPlan, oneof: "action" },
        { no: 50, name: "community_pool_spend", kind: "message", T: CommunityPoolSpend, oneof: "action" },
        { no: 51, name: "community_pool_output", kind: "message", T: CommunityPoolOutput, oneof: "action" },
        { no: 52, name: "community_pool_deposit", kind: "message", T: CommunityPoolDeposit, oneof: "action" },
        { no: 53, name: "action_dutch_auction_schedule", kind: "message", T: ActionDutchAuctionSchedule, oneof: "action" },
        { no: 54, name: "action_dutch_auction_end", kind: "message", T: ActionDutchAuctionEnd, oneof: "action" },
        { no: 55, name: "action_dutch_auction_withdraw", kind: "message", T: ActionDutchAuctionWithdrawPlan, oneof: "action" },
    ]);
    static fromBinary(bytes, options) {
        return new ActionPlan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ActionPlan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ActionPlan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ActionPlan, a, b);
    }
}
/**
 * Describes a plan for forming a `Clue`.
 *
 * @generated from message penumbra.core.transaction.v1.CluePlan
 */
export class CluePlan extends Message {
    /**
     * The address.
     *
     * @generated from field: penumbra.core.keys.v1.Address address = 1;
     */
    address;
    /**
     * The random seed to use for the clue plan.
     *
     * @generated from field: bytes rseed = 2;
     */
    rseed = new Uint8Array(0);
    /**
     * The bits of precision.
     *
     * @generated from field: uint64 precision_bits = 3;
     */
    precisionBits = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.CluePlan";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "address", kind: "message", T: Address },
        { no: 2, name: "rseed", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 3, name: "precision_bits", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new CluePlan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CluePlan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CluePlan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CluePlan, a, b);
    }
}
/**
 * Describes a plan for forming the transaction memo.
 *
 * @generated from message penumbra.core.transaction.v1.MemoPlan
 */
export class MemoPlan extends Message {
    /**
     * The plaintext.
     *
     * @generated from field: penumbra.core.transaction.v1.MemoPlaintext plaintext = 1;
     */
    plaintext;
    /**
     * The key to use to encrypt the memo.
     *
     * @generated from field: bytes key = 2;
     */
    key = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.MemoPlan";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "plaintext", kind: "message", T: MemoPlaintext },
        { no: 2, name: "key", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new MemoPlan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MemoPlan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MemoPlan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MemoPlan, a, b);
    }
}
/**
 * The encrypted memo data describing information about the purpose of a transaction.
 *
 * @generated from message penumbra.core.transaction.v1.MemoCiphertext
 */
export class MemoCiphertext extends Message {
    /**
     * The encrypted data. 528 bytes.
     *
     * @generated from field: bytes inner = 1;
     */
    inner = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.MemoCiphertext";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new MemoCiphertext().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MemoCiphertext().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MemoCiphertext().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MemoCiphertext, a, b);
    }
}
/**
 * The plaintext describing information about the purpose of a transaction.
 *
 * @generated from message penumbra.core.transaction.v1.MemoPlaintext
 */
export class MemoPlaintext extends Message {
    /**
     * The sender's return address.
     *
     * This should always be a valid address; the sender is responsible for ensuring
     * that if the receiver returns funds to this address, they will not be lost.
     *
     * @generated from field: penumbra.core.keys.v1.Address return_address = 1;
     */
    returnAddress;
    /**
     * Free-form text, up to 432 bytes long.
     *
     * @generated from field: string text = 2;
     */
    text = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.MemoPlaintext";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "return_address", kind: "message", T: Address },
        { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new MemoPlaintext().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MemoPlaintext().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MemoPlaintext().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MemoPlaintext, a, b);
    }
}
/**
 * @generated from message penumbra.core.transaction.v1.MemoPlaintextView
 */
export class MemoPlaintextView extends Message {
    /**
     * @generated from field: penumbra.core.keys.v1.AddressView return_address = 1;
     */
    returnAddress;
    /**
     * @generated from field: string text = 2;
     */
    text = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.MemoPlaintextView";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "return_address", kind: "message", T: AddressView },
        { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new MemoPlaintextView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MemoPlaintextView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MemoPlaintextView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MemoPlaintextView, a, b);
    }
}
/**
 * @generated from message penumbra.core.transaction.v1.MemoView
 */
export class MemoView extends Message {
    /**
     * @generated from oneof penumbra.core.transaction.v1.MemoView.memo_view
     */
    memoView = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.MemoView";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "visible", kind: "message", T: MemoView_Visible, oneof: "memo_view" },
        { no: 2, name: "opaque", kind: "message", T: MemoView_Opaque, oneof: "memo_view" },
    ]);
    static fromBinary(bytes, options) {
        return new MemoView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MemoView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MemoView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MemoView, a, b);
    }
}
/**
 * @generated from message penumbra.core.transaction.v1.MemoView.Visible
 */
export class MemoView_Visible extends Message {
    /**
     * @generated from field: penumbra.core.transaction.v1.MemoCiphertext ciphertext = 1;
     */
    ciphertext;
    /**
     * @generated from field: penumbra.core.transaction.v1.MemoPlaintextView plaintext = 2;
     */
    plaintext;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.MemoView.Visible";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "ciphertext", kind: "message", T: MemoCiphertext },
        { no: 2, name: "plaintext", kind: "message", T: MemoPlaintextView },
    ]);
    static fromBinary(bytes, options) {
        return new MemoView_Visible().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MemoView_Visible().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MemoView_Visible().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MemoView_Visible, a, b);
    }
}
/**
 * @generated from message penumbra.core.transaction.v1.MemoView.Opaque
 */
export class MemoView_Opaque extends Message {
    /**
     * @generated from field: penumbra.core.transaction.v1.MemoCiphertext ciphertext = 1;
     */
    ciphertext;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.transaction.v1.MemoView.Opaque";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "ciphertext", kind: "message", T: MemoCiphertext },
    ]);
    static fromBinary(bytes, options) {
        return new MemoView_Opaque().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MemoView_Opaque().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MemoView_Opaque().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MemoView_Opaque, a, b);
    }
}
